require('./accountIntervenersTooltip.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const accounts = require('constants/contactCenter/accounts');
const { OKButton } = require('components/commons/OKButton/OKButton');

class AccountIntervenersTooltip extends React.Component {

    buildHolders() {
        const { immInterveners } = this.props;
        const rawList = immInterveners.get('list').toJS();
        const holderText = formatText('interventionTypes-TITULAR');

        const listHoldersItems = rawList
            .filter(intervener => intervener.type === 'TITULAR' )
            .map((intervener, index) => {
                return (<li key={index}>{intervener.name}</li>);
            }
        );

        return (
            <div className="interveners-tooltip__holders-section">
                <p><b>{holderText}</b></p>
                <ul className="interveners-tooltip__list">{listHoldersItems}</ul>
            </div>
        );
    }

    buildInterveners() {
        const { immInterveners, accountId } = this.props;
        const rawList = immInterveners.get('list').toJS();
        const interveners = rawList.filter(intervener => intervener.type !== 'TITULAR' );
        const totalInterveners = interveners.length;

        if (totalInterveners === 0) {
            return null;
        }

        const intervenerText = formatText('interventionTypes-BENEFICIARIO');
        const totalHolders = rawList.filter(intervener => intervener.type === 'TITULAR' ).length;

        let listIntervenersItems = interveners
            .slice(0, (accounts.INTERVENERS_TOOLTIP_LIMIT - totalHolders))
            .map((intervener, index) => {
                return (<li key={index}>{intervener.name}</li>);
            }
        );

        if ((totalHolders + totalInterveners) > accounts.INTERVENERS_TOOLTIP_LIMIT) {
            const removeIntervenerUri = `/myprofile/accounts/${accountId}/details`;

            const moreLink = (
                <OKButton to={removeIntervenerUri}>
                    <FormattedText value="commons-seeMore"/>
                </OKButton>
            );

            listIntervenersItems.push(<li className="interveners-tooltip__list-item">{moreLink}</li>);
        }

        return (
            <div className="interveners-tooltip__interveners-section">
                <p><b>{intervenerText}</b></p>
                <ul className="interveners-tooltip__list">{listIntervenersItems}</ul>
            </div>
        );
    }

    buildContent() {
        return (
            <div>
                {this.buildHolders()}
                {this.buildInterveners()}
            </div>
        )
    }

    render() {
        const { immInterveners } = this.props;
        const isLoading = immInterveners.get('isLoading');
        const error = immInterveners.get('error');

        let content;

        if (isLoading) {
            content = <LoadingSection />;
        } else if (error) {
            content = <span className="interveners-tooltip__error-message">{formatText('interveners-serviceError')}</span>;
        } else if (immInterveners.get('list').size > 0) {
            content = this.buildContent();
        }

        return (<div>{content}</div>);
    }
}

AccountIntervenersTooltip.propTypes = {
    immInterveners: PropTypes.object.isRequired,
    accountId: PropTypes.string.isRequired
};

module.exports = AccountIntervenersTooltip;
